<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="审核状态：">
        <el-select v-model="query.auditStatus" placeholder="全部" clearable size="small" style="width: 120px;">
          <el-option label="待审核" :value="0" />
          <el-option label="同意申请" :value="10" />
          <el-option label="驳回申请" :value="20" />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间：">
        <!-- <el-select v-model="query.timeType" placeholder="请选择" clearable size="small" style="width: 120px;">
          <el-option label="提交时间" :value="0" />
          <el-option label="审核时间" :value="1" />
        </el-select> -->
        <el-date-picker
          v-model="dateTime"
          size="small"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始"
          end-placeholder="结束"
          style="margin-left: 10px;"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleExport" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import rechargeManualLedgerAuditApi from '@/api/finance/rechargeManualLedgerAudit'
import { filterEmpty } from '@/utils'

export default {
  data() {
    return {
      dateTime: [],
      query: {
        auditStatus: undefined,
        timeType: undefined
      }
    }
  },
  methods: {
    handleExport() {
      const params = {}
      
      // 审核状态
      if (this.query.auditStatus !== undefined && this.query.auditStatus !== null && this.query.auditStatus !== '') {
        params.auditStatus = this.query.auditStatus
      }
      
      // 时间筛选
      if (this.dateTime && this.dateTime.length > 0) {
        if (this.query.timeType === 0 || this.query.timeType === undefined) {
          // 提交时间
          params.createdTimeStart = this.dateTime[0]
          params.createdTimeEnd = this.dateTime[1]
        } else if (this.query.timeType === 1) {
          // 审核时间
          params.auditTimeStart = this.dateTime[0]
          params.auditTimeEnd = this.dateTime[1]
        }
      }
      
      return this.$common
        .confirm('是否确认导出')
        .then(() => rechargeManualLedgerAuditApi.createExportTask(filterEmpty(params)))
        .then(res => {
          if (res.code === '0') {
            this.$message.success('导出任务已创建')
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          } else {
            this.$message.error(res.msg || '导出失败')
          }
        })
        .catch(err => {
          this.$message.error(err.msg || '导出失败')
        })
    }
  }
}
</script>

